module.exports = __webpack_public_path__ + "img/mahsulot-2.664d0bf4.png";